import type { LandingPersona } from '@/hooks/useLandingPersona'

interface Props {
  persona: LandingPersona
}

export default function LandingFooter({ persona }: Props) {
  return (
    <footer className="lp-footer">
      <div className="lp-container lp-footer-grid">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span className="lp-wordmark" style={{ fontSize: 16 }}>
            <span>{persona.name}</span>
          </span>
          <span className="lp-footer-meta">© {new Date().getFullYear()}</span>
        </div>
        <nav className="lp-footer-links">
          <a href="#features">Features</a>
          <a href="#personas">Personas</a>
          <a href="#pricing">Pricing</a>
          <a href="#faq">FAQ</a>
          <a href="mailto:support@yourproject.ai">Contact</a>
          <a href="/changelog">Changelog</a>
          <a href="https://status.yourproject.ai">Status</a>
          <a href="/playbook">Playbook</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/data-deletion">Data deletion</a>
          <a href="https://instagram.com/yourproject.ai" target="_blank" rel="me noopener">
            Instagram
          </a>
          {/* TODO_YOUTUBE_URL: add the YouTube channel link here once it exists */}
        </nav>
        <div className="lp-footer-meta">
          Built with Azure, Stripe, ElevenLabs &amp; Claude.
        </div>
      </div>
    </footer>
  )
}
